import { Api } from 'utils';

class AdvertisementService {


    static admin = {
        getAdvertisingRates: async (params?: any) => Api.createResponse('admin/advertisements/get-advertisingrates', params),
        get: async (params?: any) => Api.createResponse('admin/advertisements/get', params),
        update: async (params?: any) => Api.createResponse('admin/advertisements/update', params),
        create: async (params?: any) => Api.createResponse('admin/advertisements/create', params),
        delete: async (params?: any) => Api.createResponse('admin/advertisements/delete', params),
        approve: async (params?: any) => Api.createResponse('admin/advertisements/approve', params),
    }

	static affiliate = {
		payAd: async (params?: any) => Api.createResponse('app/affiliate/advertisements/pay',params),
	}
}

export default AdvertisementService;